module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Big-Little-Lies-S2.293c0e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Big-Little-Lies-S2.jpg
// module id = IVVn
// module chunks = 0